@let model = viewModel();

<app-flow-node-inputs [inputs]="model.inputs" />

<app-flow-node-header
    [(expanded)]="expanded"
    (expandedChange)="toggle($event)"
    [type]="model.type"
    [description]="model.description"
    fDragHandle />
@if (expanded()) {
    <div class="node-form" fDragBlocker>
        @switch (model.type) {
            @case (nodeType.USER_INPUT) {
                <app-flow-node-ivr-form [formControl]="form" />
            }
            @case (nodeType.PLAY_TEXT) {
                <app-flow-node-play-text-form [formControl]="form" />
            }
            @case (nodeType.CHECK_SCHEDULE) {
                <app-flow-node-schedule-form [formControl]="form" />
            }
            @case (nodeType.QUEUE_CALL) {
                <app-flow-node-queue-form [formControl]="form" />
            }
            @case (nodeType.TO_OPERATOR) {
                <app-flow-node-operator-form [formControl]="form" />
            }
            @case (nodeType.TRANSFER_CALL) {
                <app-flow-node-transfer-form [formControl]="form" />
            }
            @case (nodeType.VOICE_MAIL) {
                <app-flow-node-voicemail-form [formControl]="form" />
            }
        }
    </div>

    <app-flow-node-body-outputs [outputs]="model.outputs" (removeConnection)="removeConnectionByOutput($event)" />
} @else {
    <app-flow-node-footer-outputs [outputs]="model.outputs" (removeConnection)="removeConnectionByOutput($event)" />
}
